"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseBoolean = parseBoolean;
function parseBoolean(rawValue) {
  return rawValue === 'true';
}
